/** @format */

import { Component, Input, OnInit } from '@angular/core';
@Component({
	selector: 'home-wysiwyg',
	templateUrl: './wysiwyg.component.html',
	styleUrl: './wysiwyg.component.scss',
	standalone: false
})
export class WysiwygComponent implements OnInit {
	@Input() addlData: any;
	@Input() data: any[];

	blocks: string[] = [];

	ngOnInit() {
		for (const datum of this.data) {
			this.blocks.push(decodeURIComponent(datum.wysiwyg));
		}
	}
}
